'use client';

import { Button, Card, Flex, Grid, ProviderIcon, Separator, Text, Tooltip } from '@workos-inc/design-system';
import * as React from 'react';
type Provider = React.ComponentProps<typeof ProviderIcon>['provider'];
type ProviderIconsGridProps = {
  figmaURL: string;
  icons: Record<string, {
    slug: Provider;
    name: string;
  }>;
};
export const ProviderIconsGrid: React.FC<ProviderIconsGridProps> = ({
  icons,
  figmaURL
}) => {
  const providerIcons = Object.entries(icons).map(([_, {
    name,
    slug
  }]) => ({
    slug,
    name
  }));
  return <Card size="1" style={{
    padding: 0
  }} data-sentry-element="Card" data-sentry-component="ProviderIconsGrid" data-sentry-source-file="provider-icons-grid.tsx">
      <Flex direction="column" gap="0" style={{
      position: 'relative',
      zIndex: 1
    }} data-sentry-element="Flex" data-sentry-source-file="provider-icons-grid.tsx">
        <Grid columns="repeat(auto-fit, minmax(48px, 1fr))" gap="6" p="5" style={{
        placeItems: 'center',
        placeContent: 'start'
      }} data-sentry-element="Grid" data-sentry-source-file="provider-icons-grid.tsx">
          {providerIcons.map((providerIcon, index) => <Tooltip key={index} content={providerIcon.name}>
              <ProviderIcon provider={providerIcon.slug} />
            </Tooltip>)}
        </Grid>
        <Separator size="4" style={{
        backgroundColor: 'var(--gray-a3)'
      }} data-sentry-element="Separator" data-sentry-source-file="provider-icons-grid.tsx" />
        <Flex align="center" gap={{
        initial: '3',
        xs: '5'
      }} justify="between" p="5" data-sentry-element="Flex" data-sentry-source-file="provider-icons-grid.tsx">
          <Flex direction="column" data-sentry-element="Flex" data-sentry-source-file="provider-icons-grid.tsx">
            <Text size="3" style={{
            color: 'var(--gray-a12)'
          }} trim="start" weight="bold" data-sentry-element="Text" data-sentry-source-file="provider-icons-grid.tsx">
              Resources
            </Text>
            <Text color="gray" size="2" style={{
            color: 'var(--gray-a11)'
          }} trim="end" data-sentry-element="Text" data-sentry-source-file="provider-icons-grid.tsx">
              The icons are also available as a{' '}
              <Text as="span" weight="medium" data-sentry-element="Text" data-sentry-source-file="provider-icons-grid.tsx">
                Figma community file
              </Text>
              .
            </Text>
          </Flex>
          <Button asChild data-sentry-element="Button" data-sentry-source-file="provider-icons-grid.tsx">
            <a href={figmaURL} rel="noreferrer" target="_blank">
              <svg fill="none" height="15" viewBox="0 0 15 15" width="15" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="provider-icons-grid.tsx">
                <path clipRule="evenodd" d="M7.00005 2.04999H5.52505C4.71043 2.04999 4.05005 2.71037 4.05005 3.52499C4.05005 4.33961 4.71043 4.99999 5.52505 4.99999H7.00005V2.04999ZM7.00005 1.04999H8.00005H9.47505C10.842 1.04999 11.95 2.15808 11.95 3.52499C11.95 4.33163 11.5642 5.04815 10.9669 5.49999C11.5642 5.95184 11.95 6.66836 11.95 7.475C11.95 8.8419 10.842 9.95 9.47505 9.95C8.92236 9.95 8.41198 9.76884 8.00005 9.46266V9.95L8.00005 11.425C8.00005 12.7919 6.89195 13.9 5.52505 13.9C4.15814 13.9 3.05005 12.7919 3.05005 11.425C3.05005 10.6183 3.43593 9.90184 4.03317 9.44999C3.43593 8.99814 3.05005 8.28163 3.05005 7.475C3.05005 6.66836 3.43594 5.95184 4.03319 5.5C3.43594 5.04815 3.05005 4.33163 3.05005 3.52499C3.05005 2.15808 4.15814 1.04999 5.52505 1.04999H7.00005ZM8.00005 2.04999V4.99999H9.47505C10.2897 4.99999 10.95 4.33961 10.95 3.52499C10.95 2.71037 10.2897 2.04999 9.47505 2.04999H8.00005ZM5.52505 8.94998H7.00005L7.00005 7.4788L7.00005 7.475L7.00005 7.4712V6H5.52505C4.71043 6 4.05005 6.66038 4.05005 7.475C4.05005 8.28767 4.70727 8.94684 5.5192 8.94999L5.52505 8.94998ZM4.05005 11.425C4.05005 10.6123 4.70727 9.95315 5.5192 9.94999L5.52505 9.95H7.00005L7.00005 11.425C7.00005 12.2396 6.33967 12.9 5.52505 12.9C4.71043 12.9 4.05005 12.2396 4.05005 11.425ZM8.00005 7.47206C8.00164 6.65879 8.66141 6 9.47505 6C10.2897 6 10.95 6.66038 10.95 7.475C10.95 8.28962 10.2897 8.95 9.47505 8.95C8.66141 8.95 8.00164 8.29121 8.00005 7.47794V7.47206Z" fill="currentColor" fillRule="evenodd" data-sentry-element="path" data-sentry-source-file="provider-icons-grid.tsx"></path>
              </svg>
              Open in Figma
            </a>
          </Button>
        </Flex>
      </Flex>
      <div style={{
      zIndex: -1,
      opacity: 0.75
    }}>
        <div style={{
        inset: 0,
        position: 'fixed',
        backgroundImage: 'linear-gradient(to bottom right, var(--purple-1), var(--gray-1), var(--color-background))'
      }}></div>
        <div style={{
        top: 0,
        width: 700,
        height: 1000,
        position: 'fixed',
        transform: 'translate(-50%, -10%) rotate(30deg)',
        backgroundImage: 'radial-gradient(farthest-side, var(--purple-3), transparent)'
      }}></div>
        <div style={{
        top: 0,
        width: 400,
        height: 600,
        position: 'fixed',
        filter: 'hue-rotate(30deg)',
        transform: 'translate(-60%, 50%) rotate(-30deg)',
        backgroundImage: 'radial-gradient(farthest-side, var(--purple-4), transparent)'
      }}></div>
      </div>
    </Card>;
};